import React, { useState, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import { Routes, Route, BrowserRouter, Outlet } from 'react-router-dom';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import './style/pfapp.scss';

import PurcharOrder from 'pages/PurchaseOrder'
import Login from 'pages/Login';
import NotValidTab from 'pages/NotValidTab';
import { PrivateRoute } from 'routes/privateRoute';
import axios from 'axios';
import { ModuleAccess } from 'utils/moduleaccess';
import InventorySearch from 'pages/Accumulations';
import CrossWalk from 'pages/CrossWalk';
import DrugCatlog from 'pages/DrugCatlog';
import Configurations from 'pages/Configuration';
import Reports from 'pages/Reports'
import AuditTool from 'pages/AuditTool';
import SbReports from 'pages/SbReports';
import PatientType from 'pages/PatientModule';
import PayorTab from 'pages/Payor';
import RxManager from 'pages/RxManager';
import Dashboard from 'pages/Dashboard';

const App = () => {
  const [modules, setModules] = useState([])
  const [orgId, setOrgId] = useState(window.selectedOrganizationId);
  const onOrgChange = (orgId) => {
    setOrgId(orgId);
  };
  const fetchModules = async () => {
    const { token_type, access_token, profile } =
      JSON.parse(localStorage.getItem('pharmaforce')) || {};
    const { sub } = profile || {};
    try {
      if (access_token) {
        renderPurchaseOrder();
       
      }

      // const { data } = await axios.get(
      //   `${process.env.REACT_APP_ENDPOINT}/RCMConfig/app/modules`,
      //   {
      //     //params: { Id: sub },
      //     headers: {
      //       'Content-type': 'application/json',
      //       Authorization: `${token_type} ${access_token}`,
      //     },
      //   }
      // );
      // if (data) {
      //   setModules(data);
      // }

    } catch (error) {
      console.log(error.message);
    }
  };

  const ThemeSelector = async () => {
    const { token_type, access_token, profile } =
      JSON.parse(localStorage.getItem('pharmaforce')) || {};
    const { sub } = profile || {};
    try {
      import('./style/pfapp.scss');
    } catch (error) {
      console.log(error.message);
    }



    return (
      <>
      </>
    )
  }

  useEffect(() => {
    //  ThemeSelector();
    // fetchModules();
  }, [])


    const renderPurchaseOrder = () => {
      if (ModuleAccess("PCO", ''))
      return (<Route path='/purchaseorder' element={<PurcharOrder orgId={orgId}/>} />)
    
   }
   const renderInventory = () => {
    if (ModuleAccess("ACC", ''))
    return (<Route path='/inventory' element={<InventorySearch orgId={orgId} />} />)
  
 }
 const renderCrossWalk = () => {
  if (ModuleAccess("CRW", ''))
  return (<Route path='/crosswalk' element={<CrossWalk orgId={orgId} />}  />)

}
const renderDrugCatlog = () => {
  if (ModuleAccess("DRC", ''))
  return (<Route path='/drugcatlog' element={<DrugCatlog orgId={orgId}/>} />)

}
const renderConfiguration = () => {
  if (ModuleAccess("CON", ''))
  return (<Route path='/configuration' element={<Configurations orgId={orgId}/>} />)

}
const renderAuditTool = () => {
  if (ModuleAccess("ADT", ''))
  return (<Route path='/AuditTool' element={<AuditTool orgId={orgId}/>} />)

}
const renderRxManager = () => {
  if (ModuleAccess("RXM", ''))
  return (<Route path='/rxManager' element={<RxManager orgId={orgId}/>} />)

}
const renderReports = () => {
  if (ModuleAccess("REP", ''))
  return (<Route path='/Reports' element={<SbReports orgId={orgId}/>} />)

}
const renderPatientModule = () => {
  if (ModuleAccess("CON", ''))
  return (<Route path='/Patient' element={<PatientType orgId={orgId}/>} />)

}
const renderPayor = () => {
   if (ModuleAccess("CON", ''))
  return (<Route path='/payor' element={<PayorTab orgId={orgId}/>} />)

}
const renderDashboard = () => {
 if (ModuleAccess("DB", ''))
 return (<Route path='/dashboard' element={<Dashboard orgId={orgId}/>} />)

}

  const renderLogin = () => {
    return (<Route index element={<Login />} />)
    
  }
  
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route element={<Outlet />}>
            <Route element={<PrivateRoute modules={modules} onAppOrgChange={onOrgChange} />}>
              {renderLogin()}
              {renderDashboard()}
              {renderRxManager()}
              {renderPurchaseOrder()}
              {renderInventory()}
              {renderCrossWalk()}
              {renderDrugCatlog()}
              {renderConfiguration()}
              {renderAuditTool()}
              {renderReports()}
            
              {renderPatientModule()}
              {renderPayor()}
            </Route>

            {/* catch all */}
            <Route path='*' element={<NotValidTab />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <ToastContainer position='top-right' autoClose={3000} />
    </>
  );
};

export default App;
